import { Button } from '@components/button';
import { IconFormIndicatorWarning } from '@components/icons/form-indicator-warning';
import { hideModal, Modal } from '@components/modal';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export const DeleteViewModal = ({
  viewName,
  onConfirm,
}: {
  viewName: string;
  onConfirm: () => void;
}) => {
  const { t } = useScopedTranslate(locale);

  const handleDelete = () => {
    onConfirm();
    hideModal();
  };

  return (
    <Modal>
      <Modal.SimpleHeader title={t('deleteView')} icon={<IconFormIndicatorWarning />} />
      <Modal.Content>
        <Stack space={4}>
          <Text text={t('areYouSure', { itemTitle: viewName })} />
          <Text color="red100" text={t('cannotBeUndone')} />
        </Stack>
      </Modal.Content>
      <Modal.Footer>
        <Stack orientation="horizontal" space={4} justify="flex-end">
          <Button variant="secondary" text={t('core.cancel')} onClick={hideModal} />
          <Button variant="primary-red" text={t('core.delete')} onClick={handleDelete} />
        </Stack>
      </Modal.Footer>
    </Modal>
  );
};

const locale = {
  en: {
    deleteView: 'Delete view',
    areYouSure: 'Are you sure you want to delete "{itemTitle}"?',
    cannotBeUndone: 'This action cannot be undone.',
  },
  is: {
    deleteView: 'Eyða ásýnd',
    areYouSure: 'Ertu viss um að þú viljir eyða "{itemTitle}"?',
    cannotBeUndone: 'Þessa aðgerð er ekki hægt að afturkalla.',
  },
};
